import {useCallback} from 'react';

import {PROJECT_TAGS} from '@/constants';
import {useTrackingManager} from '@/hooks';
import {TrackingEvent} from '@/services';

export const useChangePasswordTrackers = () => {
  const {trackEvent} = useTrackingManager();

  const trackChangePassword = useCallback(
    (eventName: TrackingEvent) => {
      trackEvent(eventName, {
        project_tag: PROJECT_TAGS.PASSWORD,
      });
    },
    [trackEvent],
  );

  return {
    trackChangePassword,
  };
};
